<template>
  <div id="app">
    <iot-dashboard />
  </div>
</template>

<script>
import IotDashboard from './component/bashboard/IotDashboard.vue';

export default {
  name: 'App',
  components: {
    IotDashboard
  }
};
</script>

<style lang="scss">
#app {
  font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  padding: 0;
}
</style>
